import React from 'react';

type Props = {
    onClick: () => void
    id?: string
    className?: string
    children: React.ReactNode
}

const Button: React.FC<Props> = ({onClick, id, className, children}) => {
    return (
        <button onClick={onClick} id={id} className={className}>{children}</button>
    )
}

export default Button
